import { Button, Dropdown, MenuProps, Row } from "antd";
import { useCallback, useMemo, useState } from "react";
import { EllipsisOutlined } from "@ant-design/icons";
import { AbuseModal } from "./components/AbuseModal";

type AbuseReportProps = {
  conversationId: string;
};

export const AbuseReport = ({ conversationId }: AbuseReportProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const openModal = useCallback(() => setIsModalOpen(true), []);

  const actions: MenuProps["items"] = useMemo(
    () => [
      {
        key: "1",
        label: <Row onClick={openModal}>Report Abuse</Row>,
      },
    ],
    [openModal],
  );

  return (
    <>
      <Dropdown
        menu={{ items: actions }}
        trigger={["click"]}
        overlayClassName="abuse-dropdown"
      >
        <Button icon={<EllipsisOutlined />} shape="circle" size="small" />
      </Dropdown>

      <AbuseModal
        conversationId={conversationId}
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
      />
    </>
  );
};
